var _mask, _g, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0mobile",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59991 0H2.28802C1.00935 0.0178212 -0.0140252 1.09131 0.000145403 2.39991V17.8759C-0.0140252 19.1845 1.00935 20.258 2.28802 20.2759H8.93904V19.2551H10.9135V20.2732H11.8878V2.39991C11.902 1.09131 10.8786 0.0178212 9.59991 0ZM10.8947 15.2243H0.98044V4.06293H10.8947V15.2243Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0mobile)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8319 -2.02759H-5.94336V22.3034H17.8319V-2.02759Z",
    fill: "#0E5AA7"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1mobile",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02331 16.2303V17.8497C1.02259 18.6271 1.63707 19.2584 2.39675 19.2606H10.9102V16.2322L1.02331 16.2303ZM6.95298 17.2342V18.2448H4.96516V17.2342H6.95298ZM9.61502 0.995728C10.3747 0.997997 10.9892 1.62926 10.9884 2.40669V3.02828H0.929688V2.40669C0.92897 1.62925 1.54344 0.997986 2.30313 0.995728H9.61502Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1mobile)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.83 -2.02759H-5.94531V22.3034H17.83V-2.02759Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMobileIcon);
export default __webpack_public_path__ + "static/media/new-mobile-icon.b386ed37597dc41361aae15e4729ce4ecaf08dbeaba00da980f15aec178348cc.svg";
export { ForwardRef as ReactComponent };